<div id="dhlApp">
  <div id="sideMenuID">
  <div class="sidenav-container-parent">
    <div #drawer class="sidenav-parent" [attr.role]="'dialog'">
      <div class="nav-list">
        <div style="height:35px">&nbsp;</div>
        <div *ngFor="let menuItem of menuItems.items(); let i = index">
          <div *ngIf="menuItem.label === '-'" class="divider"></div>
          <div *ngIf="menuItem.label === '-'" style="height:42px">&nbsp;</div>

          <div *ngIf="!menuItem.subMenu; else notShow">
            <a
              routerLink="{{ menuItem.link }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact : menuUrlArray?.indexOf(currentUrl) > -1 ?  true : false}"                  
              *ngIf="menuItem.label !== '-'"
              class="list-item"
              (click)="
                navigateURLs(menuItem.link);
                menuItems.setOpenMenuIndex(
                  $event,
                  menuItem.subMenu,
                  i === menuItems.getOpenMenuIndex() ? -1 : i
                )
              ">
              <span *ngIf="menuItem.iconType === 'IMAGE'; else icon " class="default-image">
                <img src={{menuItem.iconUrl}} style="width:24px;height:24px" type="image/svg+xml" />
              </span>
              <ng-template #icon>
                <span class="icon">{{ menuItem.icon }}</span>
              </ng-template>
              <span
                style="flex: 1 1 auto; padding: 16px; font-size:16px; font-weight:700; font-style:normal; font-stretch: 100%; -webkit-font-smoothing: antialiased;">{{
                menuItem.label | translate}}</span>
                <span
                  *ngIf="menuItem.subMenu"
                  [ngClass]="{ rotated: menuItems.getOpenMenuIndex() === i }"
                  class="icon"
                  style="transition: transform 500ms;"
                  >keyboard_arrow_down</span
                >
            </a>
          </div>

          <ng-template #notShow>
            <a
              routerLink="{{ menuItem.link }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact : menuUrlArray?.indexOf(this.currentUrl) > -1 ?  true : false}"                  
              *ngIf="menuItem.label !== '-'"
              class="list-item"
              (click)="
                navigateURLs(menuItem.link);
                menuItems.setOpenMenuIndex(
                  $event,
                  menuItem.subMenu,
                  i === menuItems.getOpenMenuIndex() ? -1 : i
                )
              ">
              <span *ngIf="menuItem.iconType === 'IMAGE'; else icon " class="default-image">
                <img src={{menuItem.iconUrl}} style="width:24px;height:24px" type="image/svg+xml" />
              </span>
              <ng-template #icon>
                <span class="icon">{{ menuItem.icon }}</span>
              </ng-template>
              <span
                style="flex: 1 1 auto; padding: 16px; font-size:16px; font-weight:700; font-style:normal; font-stretch: 100%; -webkit-font-smoothing: antialiased;">{{
                menuItem.label | translate}}</span>
              <span
              *ngIf="menuItem.subMenu" 
              [ngClass]="{ rotated: menuItems.getOpenMenuIndex() === i }"
              class="icon"
              style="transition: transform 500ms;"
              >keyboard_arrow_down</span
              >
            </a>

            <!-- {{menuItem.subMenu | json}} -->
            <div [ngClass]="{
                submenu: true,
                'submenu-visible': menuItems.getOpenMenuIndex() === i
              }">
              <a *ngFor="let subMenuItem of menuItem.subMenu; let si = index" class="list-item"
                (click)="menuItems.setSelectedSubMenuIndex(si)" [routerLink]="subMenuItem.link">
                <span [ngClass]="{
                    'submenu-selected':
                      menuItems.getSelectedSubMenuIndex() === si &&
                      menuItems.getSelectedMenuIndex() === i
                  }"
                  style="flex: 1 1 auto; padding-left: 40px; font-size:16px; font-stretch:100%; font-style:normal; font-weight:400;"
                  [ngStyle]="{
                    'background-color:#f5f5f5':
                      menuItems.getSelectedSubMenuIndex() === si &&
                      menuItems.getSelectedMenuIndex() === i
                  }">{{ subMenuItem.label }}</span>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
      
      <div *ngIf="isContactAvailable">
        <div class="divider"></div> 
        <button class="menu-item Contact_us" routerLink="/contact">Contact Us</button>
        <button class="menu-item Training-Document"> Training document</button>
      </div>    
    </div>
    <!-- CP-3746 maintenance-bg class change the white bottom and header color for maintenance screen -->
    <div class="sidenav-content" [ngClass]="{'maintenance-bg': isShowDashboard}">
      <div class="globleMessage col-xs-12" #globleMessageBanner  *ngIf="globleMessageVisible" id="globleMessageBanner">
        <span class="col-xs-10">
          TOP application would be unavailable between Sunday, 5 November 2023 11:00 AM GMT - 15:30 PM GMT
        </span>
        <span class="col-xs-2" style="    position: absolute;
        right: 20px;
        color: red;cursor: pointer;" (click)="closePopupMessge()">X</span>
      </div>
      <div *ngIf="!customerTheme" class="toolbar default-theme elevation-z3" [ngStyle]="{'top': dynamicHeightOfBanner ? dynamicHeightOfBanner + 'px' : 0}">
        <button type="button" aria-label="Toggle sidenav" *ngIf="showHeader && !((isHandset$ | async) === false)"
          class="icon-button" (click)="toggleDrawer()"
          style="margin-right: 16px; width:40px; height: 40px">
          <span class="icon" aria-label="Side nav toggle icon">menu</span>
        </button>
        <div>
          <img src="../assets/images/dhl-logo.svg" class="img-dimension" />
        </div>
        <div *ngIf="(showHeader && multipleCustomer && !isMultilanguageAvailable)" class="switch-user-37">
          <app-app-switch-user></app-app-switch-user>
        </div>
        <!-- <div *ngIf="(showHeader && multipleCustomer && isMultilanguageAvailable)"
          style="position: absolute; right: 50px;">
          <app-app-switch-user></app-app-switch-user>
        </div> -->
        <div *ngIf="(showHeader && !multipleCustomer && isMultilanguageAvailable)" class="switch-user-37">
          <app-app-switch-user></app-app-switch-user>
        </div>
        <div *ngIf="(showHeader && multipleCustomer && isMultilanguageAvailable)" class="switch-user-50">
          <app-app-switch-user></app-app-switch-user>
        </div>
      </div>
      <div #customerThemeToolbar *ngIf="customerTheme" class="toolbar customer-theme elevation-z3" [ngStyle]="{'top': dynamicHeightOfBanner ? dynamicHeightOfBanner + 'px' : 0}">
        <button type="button" aria-label="Toggle sidenav" *ngIf="showHeader && !((isHandset$ | async) === false)"
          class="icon-button" (click)="toggleDrawer()" style="width:40px; height: 40px ">
          <span class="icon" aria-label="Side nav toggle icon">menu</span>
        </button>
        <div class="dhl-logo">
          <img src="../assets/images/dhl-logo.svg" class="img-dimension" />
          <span>Transportation Management</span>
        </div>
        <div class="customer-logo">
          <!-- <img src="{{logo}}" style="max-height: 25px;max-width: 150px;"/> -->
          <img src="{{logo}}" (error)="imgaeLoadError()" />
        </div>
        <div class="customer-logoM">
          <img src="{{logoM}}" (error)="imgaeLoadError()" />
        </div>
        <div class="customer-logoS">
          <img src="{{logoS}}" (error)="imgaeLoadError()" />
        </div>
        <!-- <div *ngIf="showHeader && multipleCustomer" style="position: absolute; right: -34px;">
          <app-app-switch-user></app-app-switch-user>
        </div> -->
        <div *ngIf="(showHeader && multipleCustomer && !isMultilanguageAvailable)" class="switch-user-37">
          <app-app-switch-user></app-app-switch-user>
        </div>
        <!-- <div *ngIf="(showHeader && multipleCustomer && isMultilanguageAvailable)"
          style="position: absolute; right: 50px;">
          <app-app-switch-user></app-app-switch-user>
        </div> -->
        <div *ngIf="(showHeader && !multipleCustomer && isMultilanguageAvailable)" class="switch-user-37">
          <app-app-switch-user></app-app-switch-user>
        </div>
        <div *ngIf="(showHeader && multipleCustomer && isMultilanguageAvailable)" class="switch-user-50">
          <app-app-switch-user></app-app-switch-user>
        </div>
      </div>

      <div class="sidenav-container">
        <!-- Mobile overlay -->
        <div *ngIf="(isHandset$ | async) && isMobileSidenavOpen" class="mobile-overlay" (click)="closeMobileSidenav()"></div>
        
        <div *ngIf="showHeader" [ngClass]="{
            sidenav: true,
            desktop: (isHandset$ | async) === false,
            'elevation-z3': true,
            'mobile-open': (isHandset$ | async) && isMobileSidenavOpen
          }" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'">
          <div class="nav-list">
            <div style="height:35px">&nbsp;</div>
            <div *ngFor="let menuItem of menuItems.items(); let i = index">
              <div *ngIf="menuItem.label === '-'" class="divider"></div>
              <div *ngIf="menuItem.label === '-'" style="height:42px">&nbsp;</div>

              <div *ngIf="!menuItem.subMenu; else notShow">
                <a
                  routerLink="{{ menuItem.link }}"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact : menuUrlArray?.indexOf(currentUrl) > -1 ?  true : false}"                  
                  *ngIf="menuItem.label !== '-'"
                  class="list-item"
                  (click)="
                  navigateURLs(menuItem.link);
                    menuItems.setOpenMenuIndex(
                      $event,
                      menuItem.subMenu,
                      i === menuItems.getOpenMenuIndex() ? -1 : i
                    )
                  ">
                  <span *ngIf="menuItem.iconType === 'IMAGE'; else icon " class="default-image">
                    <img src={{menuItem.iconUrl}} style="width:24px;height:24px" type="image/svg+xml" />
                  </span>
                  <ng-template #icon>
                    <span class="icon">{{ menuItem.icon }}</span>
                  </ng-template>

                  <span class="menu-label">{{ menuItem.label | translate }}</span>
                <span
                  *ngIf="menuItem.subMenu"
                  [ngClass]="{ rotated: menuItems.getOpenMenuIndex() === i }"
                  class="icon"
                  style="transition: transform 500ms;"
                  >keyboard_arrow_down</span
                >
                </a>
              </div>

              <ng-template #notShow>
                <a
                  routerLink="{{ menuItem.link }}"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact : menuUrlArray?.indexOf(currentUrl) > -1 ?  true : false}"                  
                  *ngIf="menuItem.label !== '-'"
                  class="list-item"
                  (click)="
                    navigateURLs(menuItem.link);
                    menuItems.setOpenMenuIndex(
                      $event,
                      menuItem.subMenu,
                      i === menuItems.getOpenMenuIndex() ? -1 : i
                    )
                  ">
                  <span *ngIf="menuItem.iconType === 'IMAGE'; else icon " class="default-image">
                    <img src={{menuItem.iconUrl}} style="width:24px;height:24px" type="image/svg+xml" />
                  </span>
                  <ng-template #icon>
                    <span class="icon">{{ menuItem.icon }}</span>
                  </ng-template>

                  <span class="menu-label">{{ menuItem.label | translate }}</span>
                  <span *ngIf="menuItem.subMenu" [ngClass]="{ rotated: menuItems.getOpenMenuIndex() === i }"
                    class="icon" style="transition: transform 500ms;">keyboard_arrow_down</span>
                </a>

                <!-- {{menuItem.subMenu | json}} -->
                <div [ngClass]="{
                    submenu: true,
                    'submenu-visible': menuItems.getOpenMenuIndex() === i
                  }">
                  <a *ngFor="let subMenuItem of menuItem.subMenu; let si = index" class="list-item"
                    (click)="menuItems.setSelectedSubMenuIndex(si)" [routerLink]="subMenuItem.link">
                    <span [ngClass]="{
                        'submenu-selected':
                          menuItems.getSelectedSubMenuIndex() === si &&
                          menuItems.getSelectedMenuIndex() === i
                      }"
                      style="flex: 1 1 auto; padding-left: 40px; font-size:16px; font-stretch:100%; font-style:normal; font-weight:400;"
                      [ngStyle]="{
                        'background-color:#f5f5f5':
                          menuItems.getSelectedSubMenuIndex() === si &&
                          menuItems.getSelectedMenuIndex() === i
                      }">{{ subMenuItem.label }}</span>
                  </a>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="sidenav-content" (scroll)="onScroll($event)" [ngClass]="{'maintenance-bg': isShowDashboard}">
          <main id="main" fxflex="100%">
            <div class="main-content-area" [ngClass]="{'maintenance-error': isShowDashboard}">
              <!-- begim main content routing area -->
              <router-outlet></router-outlet>
              <!-- end main content routing area -->
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="cookie-banner" id="cookieBanner" *ngIf = "showCookieBanner">
  <h5 class="cookie-title">Consent for Data Processing</h5>
  <div class="cookie-container">
    <p>This website uses cookies and similar technologies (hereinafter 
      "Technologies") that enable us to provide an optimized online experience and tailor content 
      to your interests. By clicking "Accept all", you consent that these Technologies may be stored 
      and read on your device. This includes the creation of profiles to make our services as easy to
        use and as customer-specific as possible and to support our marketing activities. Your consent
        includes the transfer of data to countries with a level of data protection not equivalent to 
        the European Union. 
      <a href="https://www.dhl.com/privacy" target="_blank" style="color: #fff; text-decoration: underline;">Privacy Notice</a>&nbsp;
      <a href="https://www.dhl.com/legal-notice" target="_blank" style="color: #fff; text-decoration: underline;">Legal Notice</a>
    </p>
    <button (click)="acceptCookies()" type="button" class="btn buttons-primary dhl-button-v2">Accept All</button>
  </div>
</div>
